export function findActiveRoute(pathname: string, routes: string[]): string | undefined {
  return routes.reduce<string | undefined>(
    (best, route) => (pathname.startsWith(route) && route.length > (best?.length ?? 0) ? route : best),
    undefined
  );
}
